import React, { useState, useEffect, useRef } from "react";
import { Box, CardContent, Tab, Tabs, Typography } from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { BarChart } from "@mui/x-charts/BarChart";

const TopAssetsByCost = ({ responseFem, responseBem }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [top5Assets, setTop5Assets] = useState([]);
  const chartRef = useRef(null);

  const handleTabChange = (_event, newValue) => {
    setSelectedTab(newValue);
  };

  // Function to extract top 5 assets based on the selected response (FEM or BEM)
  const getTopAssetsByCost = (response) => {
    if (!response || !response.topAssetsbyMaintenanceCostLists) return [];

    return response.topAssetsbyMaintenanceCostLists
      .sort((a, b) => b.totalmaintenancecost - a.totalmaintenancecost)
      .slice(0, 5);
  };

  // Update top 5 assets when tab changes
  useEffect(() => {
    if (selectedTab === 0) {
      setTop5Assets(getTopAssetsByCost(responseFem));
    } else {
      setTop5Assets(getTopAssetsByCost(responseBem));
    }
  }, [selectedTab, responseFem, responseBem]);

  // Preparing chart data for BarChart
  const chartData = {
    dataset: top5Assets.map((item) => ({
      month: item.assetNo,
      cost: item.totalmaintenancecost,
    })),
  };
  useEffect(() => {
    if (chartRef.current) {
      // Select the tspan element
      const tspanElement = chartRef.current.querySelector(
        ".MuiChartsAxis-label tspan"
      );
      if (tspanElement) {
        tspanElement.setAttribute("dy", "-60px"); // Change the dy value
      }
    }
  }, [top5Assets]);
  const hasData = top5Assets.length === 0;

  return (
    <StyledCard>
      <CardContent>
        <Typography
          mb={1.5}
          variant="h5"
          fontWeight={700}
          color={"text.primary"}
        >
          Top Assets by Maintenance Cost
        </Typography>

        {/* Tabs */}
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          aria-label="Top Assets by Maintenance Cost"
        >
          <Tab label="FEMS" />
          <Tab label="BEMS" />
        </Tabs>

        {/* Chart Container with a fixed height to avoid collapsing */}
        <Box width={"100%"} style={{ height: 300 }} ref={chartRef}>
          <BarChart
            dataset={chartData.dataset}
            yAxis={[{ scaleType: "band", label: "Assets", dataKey: "month" }]}
            series={[{ dataKey: "cost", color: "#fd7e14",label: "Cost (RM)"  }]}
            xAxis={[{ disableLine: hasData }]}
            layout="horizontal"
            margin={{ left: 120 }}
            slotProps={{
              legend: { hidden: hasData }, 
            }}
          />
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default TopAssetsByCost;
